import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { getsinglebuildsheetData, updatedataremotefittingobjects } from "../../Api/iron"
import { } from "../../Api/prescriptionApis"
import TabFormData from "../DashboardComponents/TabsData/TabFormData";
import TabNotesData from "../DashboardComponents/TabsData/TabNotesData";
import { FaAngleUp, FaStar } from "react-icons/fa";
import { Accordion } from "react-bootstrap";
import { FaCheck } from "react-icons/fa";
import Loader2 from "../DashboardComponents/Loader/Loader2";

const initData = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    height_ft: "",
    height_in: "",
    wrist_to_floor: "",
    shoulder_to_wrist: "",
    elbow_to_wrist: "",
    fitter_name: "",
};



function BuildTab3({ project_id, project_step = "history", currentpagename, buildsheets, ondeleteChange, allmodels, remortFittingFormData, allMakeData, SinglePrescription, prescriptioncalc, setcheckdropdwondata }) {

    const [historydata, setHistorydata] = useState([]);
    const [formData, setFormData] = useState(initData);
    const [prescription, setPrescription] = useState(0);
    const [buildsheetData, setBuildsheetData] = useState(0);
    const [current_project_step, setCurrent_project_step] = useState(project_step);
    const [loading, setLoading] = useState(false);

    const [makedata, setMakeData] = useState([]);
    const [shaftdata, setShaftData] = useState([]);
    const [gripdata, setGripData] = useState([]);

    const [optimalHeads, setOptimalHeads] = useState(0);
    const [optimalShafts, setOptimalShafts] = useState(0);
    const [optimalGrips, setOptimalGrips] = useState(0);

    const [optimalHeadsobject, setOptimalHeadsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    const [optimalShaftsobject, setOptimalShaftsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    const [optimalGripsobject, setOptimalGripsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    useEffect(() => {
        if (typeof setcheckdropdwondata === 'function') {
            const combinedData = {
                optimalHeads: optimalHeadsobject,
                optimalShafts: optimalShaftsobject,
                optimalGrips: optimalGripsobject
            };

            setcheckdropdwondata(combinedData); // Pass the combined data to the parent
        }
    }, [optimalHeadsobject, optimalShaftsobject, optimalGripsobject]);


    const [head1, setHead1] = useState('');
    const [head2, setHead2] = useState('');
    const [head3, setHead3] = useState('');

    const [Shaft1, setShaft1] = useState('');
    const [Shaft2, setShaft2] = useState('');
    const [Shaft3, setShaft3] = useState('');

    const [Grip1, setGrip1] = useState('');
    const [Grip2, setGrip2] = useState('');
    const [Grip3, setGrip3] = useState('');

    const [allmodelsdata, setAllmodelsdata] = useState([]);

    useEffect(() => {
        if (allmodels && allmodels.length > 0 && allmodelsdata && allmodelsdata.length === 0) {
            setAllmodelsdata(allmodels);
        }
    }, [allmodels]);


    const getDataById = () => {
        setFormData(remortFittingFormData);

    }

    const getmakedata = (id) => {
        const data = {
            type_id: id
        }
        const filtermakedata = allMakeData && allMakeData.filter((item) => item.item_type_id.includes(id));
        if (id === 4) {
            setMakeData(filtermakedata);
        }
        if (id === 7) {
            setShaftData(filtermakedata);
        }
        if (id === 8) {
            setGripData(filtermakedata);
        }
    }

    useEffect(() => {
        if (allMakeData.length > 0) {
            getmakedata(4);
            getmakedata(7);
            getmakedata(8);
        }
    }, [allMakeData]);


    const getbuildsheetscript = () => {

        if (prescriptioncalc) {
            setOptimalHeads(parseInt(prescriptioncalc.optimalHeadsStar));
            setOptimalShafts(parseInt(prescriptioncalc.optimalShaftsStar));
            setOptimalGrips(parseInt(prescriptioncalc.optimalGripsStar));
            // setbrandsData(prescriptioncalc);
        }
    }

    const getData = () => {
        switch (current_project_step) {
            case "history":
                getDataById();
                getprescriptionDataById();
                getbuildsheetDataById();
                getbuildsheetscript();
                break;
            case "prescription":
                getDataById();
                getprescriptionDataById();
                getbuildsheetDataById();
                getbuildsheetscript();
                break;
            case "buildsheet":
                getDataById();
                getbuildsheetscript();
                break;
            case "stagestation":
                getDataById();
                getprescriptionDataById();
                getbuildsheetDataById();
                getbuildsheetscript();
                break;
            case "buildstation":
                getDataById();
                getprescriptionDataById();
                getbuildsheetDataById();
                getbuildsheetscript();
                break;
            case "shipstation":
                getDataById();
                getprescriptionDataById();
                getbuildsheetDataById();
                getbuildsheetscript();
                break;
            default:
                getDataById();
                getprescriptionDataById();
                getbuildsheetDataById();
                getbuildsheetscript();
                break;
        }
    }

    const getprescriptionDataById = () => {
        if (SinglePrescription) {
            setPrescription(SinglePrescription);
        }
    }

    const getbuildsheetDataById = () => {
        getsinglebuildsheetData({ project_id: project_id }).then((res) => {
            // console.log("calling api", "1");
            if (res?.code === 200) {
                const buildsheetData = res.data.data;
                setBuildsheetData(buildsheetData);
            } else {
                console.log(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }


    useEffect(() => {
        if (project_id) {
            getData();
        }
    }, [project_id])


    const [isTabVisible, setIsTabVisible] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 991) {
                setIsTabVisible(true);
            } else {
                setIsTabVisible(false);
            }
        };

        // Set the initial state
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleNestedChange = (section, option, subField, value) => {

        if (allmodelsdata.length > 0) {
            const optionKey = `option${option}`;
            let type_id = "";
            switch (section) {
                case "optimalHeads":
                    type_id = "4";
                    break;
                case "optimalShafts":
                    type_id = "7";
                    break;
                case "optimalGrips":
                    type_id = "8";
                    break;
                default:
                    break;
            }

            // Filter the models from allmodels array
            const filteredModels = allmodelsdata.filter(model =>
                model.Make === value && model.type_id === type_id
            );


            // Set the data based on section, subField, and option
            if (filteredModels.length > 0) {
                const data = filteredModels;

                if (section === 'optimalHeads') {
                    switch (option) {
                        case 1:
                            console.log('head 1', data);
                            setHead1(data);
                            break;
                        case 2:
                            setHead2(data);
                            break;
                        case 3:
                            setHead3(data);
                            break;
                        default:
                            break;
                    }
                }

                if (section === 'optimalShafts') {
                    switch (option) {
                        case 1:
                            setShaft1(data);
                            break;
                        case 2:
                            setShaft2(data);
                            break;
                        case 3:
                            setShaft3(data);
                            break;
                        default:
                            break;
                    }
                }

                if (section === 'optimalGrips') {
                    switch (option) {
                        case 1:
                            setGrip1(data);
                            break;
                        case 2:
                            setGrip2(data);
                            break;
                        case 3:
                            setGrip3(data);
                            break;
                        default:
                            break;
                    }
                }

                const updateData = (setFunction, currentData) => {
                    setFunction(prevData => ({
                        ...prevData,
                        [optionKey]: { // Update the correct option (option1, option2, option3)
                            ...prevData[optionKey],
                            [subField]: value // Update the specific field (make or model)
                        }
                    }));
                };

                // Update the correct section (optimalHeads, optimalShafts, or optimalGrips)
                if (section === 'optimalHeads') {
                    updateData(setOptimalHeadsobject, optimalHeadsobject);
                } else if (section === 'optimalShafts') {
                    updateData(setOptimalShaftsobject, optimalShaftsobject);
                } else if (section === 'optimalGrips') {
                    updateData(setOptimalGripsobject, optimalGripsobject);
                }
            } else {
                console.log("");
            }
        }
    };

    // const handleNestedChangeModel = (section, option, subField, value) => {
    //     const optionKey = `option${option}`;

    //     const updateData = (setFunction, currentData) => {
    //         setFunction(prevData => ({
    //             ...prevData,
    //             [optionKey]: { // Update the correct option (option1, option2, option3)
    //                 ...prevData[optionKey],
    //                 [subField]: value // Update the specific field (make or model)
    //             }
    //         })); 
    //         updatedataremotefitting(section, currentData);
    //     }; 

    //     // Update the correct section (optimalHeads, optimalShafts, or optimalGrips)
    //     if (section === 'optimalHeads') {
    //         updateData(setOptimalHeadsobject, optimalHeadsobject);
    //         // updatedataremotefitting(section,optimalHeadsobject);
    //     } else if (section === 'optimalShafts') {
    //         updateData(setOptimalShaftsobject, optimalShaftsobject);
    //         // updatedataremotefitting(section,optimalShaftsobject);
    //     } else if (section === 'optimalGrips') {
    //         updateData(setOptimalGripsobject, optimalGripsobject);
    //         // updatedataremotefitting(section,optimalGripsobject);
    //     }
    // };

    const handleNestedChangeModel = (section, option, subField, value) => {
        const optionKey = `option${option}`;

        const updateData = (setFunction, prevData) => {
            const updatedData = {
                ...prevData,
                [optionKey]: { // Update the correct option (option1, option2, option3)
                    ...prevData[optionKey],
                    [subField]: value // Update the specific field (make or model)
                }
            };

            setFunction(updatedData); // Set the updated data to state
            updatedataremotefitting(section, updatedData); // Pass the updated data to the function
        };

        // Update the correct section (optimalHeads, optimalShafts, or optimalGrips)
        if (section === 'optimalHeads') {
            updateData(setOptimalHeadsobject, optimalHeadsobject);
        } else if (section === 'optimalShafts') {
            updateData(setOptimalShaftsobject, optimalShaftsobject);
        } else if (section === 'optimalGrips') {
            updateData(setOptimalGripsobject, optimalGripsobject);
        }
    };

    const updatedataremotefitting = (type, object) => {
        setLoading(true);
        const data = {
            type: type,
            data: JSON.stringify(object),
            project_id: project_id
        }
        updatedataremotefittingobjects(data).then((res) => {
            // console.log("calling api", "1");
            if (res?.code === 200) {
                const buildsheetData = res.data.data
            } else {
                console.log(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        }).finally(() => {
            setLoading(false);
        })
    }

    useEffect(() => {
        if (remortFittingFormData?.optimalHeads) {
            setOptimalHeadsobject(prevState => ({
                ...prevState, // Preserve any existing data
                ...remortFittingFormData.optimalHeads // Update with new data
            }));
        }

        if (remortFittingFormData?.optimalShafts) {
            setOptimalShaftsobject(prevState => ({
                ...prevState,
                ...remortFittingFormData.optimalShafts
            }));
        }

        if (remortFittingFormData?.optimalGrips) {
            setOptimalGripsobject(prevState => ({
                ...prevState,
                ...remortFittingFormData.optimalGrips
            }));
        }
    }, [remortFittingFormData]);


    useEffect(() => {
        if (allmodelsdata.length > 0) {
            handleNestedChange('optimalHeads', 1, 'make', remortFittingFormData?.optimalHeads?.option1?.make);
            handleNestedChange('optimalHeads', 2, 'make', remortFittingFormData?.optimalHeads?.option2?.make);
            handleNestedChange('optimalHeads', 3, 'make', remortFittingFormData?.optimalHeads?.option3?.make);

            handleNestedChange('optimalShafts', 1, 'make', remortFittingFormData?.optimalShafts?.option1?.make);
            handleNestedChange('optimalShafts', 2, 'make', remortFittingFormData?.optimalShafts?.option2?.make);
            handleNestedChange('optimalShafts', 3, 'make', remortFittingFormData?.optimalShafts?.option3?.make);

            handleNestedChange('optimalGrips', 1, 'make', remortFittingFormData?.optimalGrips?.option1?.make);
            handleNestedChange('optimalGrips', 2, 'make', remortFittingFormData?.optimalGrips?.option2?.make);
            handleNestedChange('optimalGrips', 3, 'make', remortFittingFormData?.optimalGrips?.option3?.make);
        }

    }, [allmodelsdata]);

    return (

        <>
            {loading && <Loader2 />}
            {
                remortFittingFormData.firstname != "" ? (<>
                    <div className="tab-container tab-club-fitting">

                        {project_step === "prescription" ? (
                            <Tabs
                                defaultActiveKey="results"
                                id="uncontrolled-tab-example"
                                className="club-fitting-tab new_mobile_tab tab-wrapper"
                            >
                                <Tab eventKey="results" title="Optimals">
                                    <div className="tab-box-section mb-4" style={{
                                        pointerEvents: SinglePrescription === 0 ? 'auto' : 'none'
                                    }}>
                                        <div className="">
                                            <div className="club-fitting-card black_box">
                                                <div className="gab_title">
                                                    <div class="gab_text"><h5>Optimal Heads</h5></div>
                                                    <div className="collapsed">
                                                        {/* <div className="gab_icon ">
                                                            <FaCheck />
                                                        </div> */}
                                                        <div className={`head_check ${optimalHeadsobject?.option1?.make && optimalHeadsobject?.option1?.model &&
                                                            optimalHeadsobject?.option2?.make && optimalHeadsobject?.option2?.model &&
                                                            optimalHeadsobject?.option3?.make && optimalHeadsobject?.option3?.model
                                                            ? 'active' : ''
                                                            }`}>
                                                            <FaCheck />
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group prescription-note">
                                                <div className="row mb-3">

                                                    <div className="col-md-6">
                                                        <select style={{textTransform:"capitalize"}} value={optimalHeadsobject?.option1?.make} onChange={(e) => handleNestedChange('optimalHeads', 1, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value="" disabled>Make</option>
                                                            {makedata && makedata.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <select style={{textTransform:"capitalize"}} value={optimalHeadsobject?.option1?.model} onChange={(e) => handleNestedChangeModel('optimalHeads', 1, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value="" disabled>Model</option>
                                                            {head1 && head1.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <select style={{textTransform:"capitalize"}} value={optimalHeadsobject?.option2?.make} onChange={(e) => handleNestedChange('optimalHeads', 2, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value={0}>Make</option>
                                                            {makedata && makedata.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <select style={{textTransform:"capitalize"}} value={optimalHeadsobject?.option2?.model} onChange={(e) => handleNestedChangeModel('optimalHeads', 2, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value={0}>Model</option>
                                                            {head2 && head2.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <select style={{textTransform:"capitalize"}} value={optimalHeadsobject?.option3?.make} onChange={(e) => handleNestedChange('optimalHeads', 3, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value={0}>Make</option>
                                                            {makedata && makedata.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <select style={{textTransform:"capitalize"}} value={optimalHeadsobject?.option3?.model} onChange={(e) => handleNestedChangeModel('optimalHeads', 3, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value={0}>Model</option>
                                                            {head3 && head3.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-box-section mb-4" style={{
                                        pointerEvents: SinglePrescription === 0 ? 'auto' : 'none'
                                    }}>
                                        <div className="">
                                            <div className="club-fitting-card black_box">
                                                <div className="gab_title">
                                                    <div class="gab_text"><h5>Optimal Shafts</h5></div>
                                                    <div className="collapsed">
                                                        {/* <div className="gab_icon ">
                                                            <FaCheck />
                                                        </div> */}
                                                        <div className={`head_check ${optimalShaftsobject?.option1?.make && optimalShaftsobject?.option1?.model &&
                                                            optimalShaftsobject?.option2?.make && optimalShaftsobject?.option2?.model &&
                                                            optimalShaftsobject?.option3?.make && optimalShaftsobject?.option3?.model
                                                            ? 'active' : ''
                                                            }`}>
                                                            <FaCheck />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group prescription-note">
                                                <div className="row mb-3">

                                                    <div className="col-md-6">
                                                        <select style={{textTransform:"capitalize"}} value={optimalShaftsobject?.option1?.make || ""} onChange={(e) => handleNestedChange('optimalShafts', 1, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value="" disabled>Make</option>
                                                            {shaftdata && shaftdata.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <select style={{textTransform:"capitalize"}} value={optimalShaftsobject?.option1?.model || ""} onChange={(e) => handleNestedChangeModel('optimalShafts', 1, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value="" disabled>Model</option>
                                                            {Shaft1 && Shaft1.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <select style={{textTransform:"capitalize"}} value={optimalShaftsobject?.option2?.make || ""} onChange={(e) => handleNestedChange('optimalShafts', 2, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value="" disabled>Make</option>
                                                            {shaftdata && shaftdata.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <select style={{textTransform:"capitalize"}} value={optimalShaftsobject?.option2?.model || ""} onChange={(e) => handleNestedChangeModel('optimalShafts', 2, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value="" disabled>Model</option>
                                                            {Shaft2 && Shaft2.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <select style={{textTransform:"capitalize"}} value={optimalShaftsobject?.option3?.make || ""} onChange={(e) => handleNestedChange('optimalShafts', 3, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value="" disabled>Make</option>
                                                            {shaftdata && shaftdata.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <select style={{textTransform:"capitalize"}} value={optimalShaftsobject?.option3?.model || ""} onChange={(e) => handleNestedChangeModel('optimalShafts', 3, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value="" disabled>Model</option>
                                                            {Shaft3 && Shaft3.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-box-section mb-4" style={{
                                        pointerEvents: SinglePrescription === 0 ? 'auto' : 'none'
                                    }}>
                                        <div className="">
                                            <div className="club-fitting-card black_box">
                                                <div className="gab_title">
                                                    <div class="gab_text"><h5>Optimal Grips</h5></div>
                                                    <div className="collapsed">
                                                        {/* <div className="gab_icon ">
                                                            <FaCheck />
                                                        </div> */}
                                                        <div className={`head_check ${optimalGripsobject?.option1?.make && optimalGripsobject?.option1?.model &&
                                                            optimalGripsobject?.option2?.make && optimalGripsobject?.option2?.model &&
                                                            optimalGripsobject?.option3?.make && optimalGripsobject?.option3?.model
                                                            ? 'active' : ''
                                                            }`}>
                                                            <FaCheck />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group prescription-note">
                                                <div className="row mb-3">

                                                    <div className="col-md-6">
                                                        <select style={{textTransform:"capitalize"}} value={optimalGripsobject?.option1?.make} onChange={(e) => handleNestedChange('optimalGrips', 1, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value="" disabled>Make</option>
                                                            {gripdata && gripdata.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <select style={{textTransform:"capitalize"}} value={optimalGripsobject?.option1?.model} onChange={(e) => handleNestedChangeModel('optimalGrips', 1, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value="" disabled>Model</option>
                                                            {Grip1 && Grip1.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <select style={{textTransform:"capitalize"}} value={optimalGripsobject?.option2?.make} onChange={(e) => handleNestedChange('optimalGrips', 2, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value="" disabled>Make</option>
                                                            {gripdata && gripdata.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <select style={{textTransform:"capitalize"}} value={optimalGripsobject?.option2?.model} onChange={(e) => handleNestedChangeModel('optimalGrips', 2, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value="" disabled>Model</option>
                                                            {Grip2 && Grip2.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <select style={{textTransform:"capitalize"}} value={optimalGripsobject?.option3?.make} onChange={(e) => handleNestedChange('optimalGrips', 3, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value="" disabled>Make</option>
                                                            {gripdata && gripdata.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <select style={{textTransform:"capitalize"}} value={optimalGripsobject?.option3?.model} onChange={(e) => handleNestedChangeModel('optimalGrips', 3, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                            <option value="" disabled>Model</option>
                                                            {Grip3 && Grip3.map((item) => (
                                                                <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey="client" title="Client">
                                    <div className="tab-box-section">
                                        <TabFormData project_id={project_id} remortFittingFormData={remortFittingFormData} />
                                    </div>
                                </Tab>
                                <Tab eventKey="notes" title="Notes">
                                    <TabNotesData project_id={project_id} />
                                </Tab>
                            </Tabs>

                        ) : project_step === "buildsheet" ? (
                            <>
                                <Tabs
                                    defaultActiveKey={formData?.type === "0" ? "script" : "client"}
                                    id="uncontrolled-tab-example"
                                    className={formData?.type === "0" ? "club-fitting-tab new_mobile_tab tab-wrapper" : "club-fitting-tab club_new_tab new_mobile_tab tab-wrapper"}
                                >
                                    {
                                        formData?.type === "0" && (
                                            <Tab eventKey="script" title="Script">
                                                <div className="tab-box-section mb-4">
                                                </div>
                                            </Tab>
                                        )
                                    }
                                    <Tab eventKey="client" title="Client">
                                        <div className="tab-box-section">
                                            <TabFormData project_id={project_id} />
                                        </div>
                                    </Tab>
                                    <Tab eventKey="notes" title="Notes">
                                        <TabNotesData project_id={project_id} />
                                    </Tab>
                                </Tabs>
                            </>



                        ) : (
                            <Tabs
                                defaultActiveKey="result"
                                id="uncontrolled-tab-example"
                                className="club-fitting-tab new_mobile_tab tab-wrapper"
                            >
                                <Tab eventKey="result" title="Results">
                                </Tab>
                                <Tab eventKey="client" title="Client">
                                    <div className="tab-box-section">
                                        <TabFormData project_id={project_id} remortFittingFormData={remortFittingFormData} />
                                    </div>
                                </Tab>
                                <Tab eventKey="notes" title="Notes">
                                    <TabNotesData project_id={project_id} />
                                </Tab>
                            </Tabs>
                        )}
                    </div>
                </>) : (<> </>)
            }

        </>


    );
}

export default BuildTab3;


